import { AppLoader } from '@/components/AppLoader'
import { AppSidebar } from '@/components/navigation/AppSidebar'
import { BottomTabs } from '@/components/navigation/BottomTabs'
import { SidebarProvider } from '@/components/ui/sidebar'
import { useIsMobile } from '@/hooks/useIsMobile'
import { cn } from '@/lib/utils'
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { useInitializeUserData } from '@/hooks/useInitializeUserData'

export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ context, location }) => {
    let shouldRedirect = false

    if (context.auth.isPending) {
      const isAuthenticated = await context.auth.waitForSession()
      if (!isAuthenticated) {
        shouldRedirect = true
      }
    }

    if (!context.auth.isAuthenticated) {
      shouldRedirect = true
    }

    if (shouldRedirect) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href,
        },
      })
    }
  },
  component: AppLayout,
  pendingComponent: () => <AppLoader />,
})

function AppLayout() {
  const isMobile = useIsMobile()

  useInitializeUserData()

  return (
    <SidebarProvider>
      <div className="flex flex-1 min-h-screen">
        {!isMobile && <AppSidebar />}
        <main
          className={cn(
            'flex flex-col flex-1 w-full md:max-w-[652px] md:mx-auto md:items-center md:justify-center',
            isMobile && 'pb-20',
          )}
        >
          <Outlet />
        </main>
        {isMobile && <BottomTabs />}
      </div>
    </SidebarProvider>
  )
}
